(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global['se-org-no'] = {})));
}(this, (function (exports) { 'use strict';

  var getControlDigit = function getControlDigit(input) {
    var digits = input.substr(0, 9).split('');

    var factor = 1;
    var factoredDigits = digits.map(function (d) {
      factor = factor === 1 ? 2 : 1;
      return (parseInt(d, 10) * factor + '').split('');
    });

    var flattenedFactoredDigits = [].concat.apply([], factoredDigits);

    var sum = flattenedFactoredDigits.reduce(function (s, d) {
      return parseInt(s, 10) + parseInt(d, 10);
    });

    var controlDigit = 10 - sum % 10;

    return controlDigit < 10 ? controlDigit : 0;
  };

  var hasValidControlDigit = function hasValidControlDigit(input) {
    return input.substr(9) === getControlDigit(input) + '';
  };

  function getSsnDate(input) {
    var thisYear = new Date().getFullYear() + '';
    var thisCentury = parseInt(thisYear.substr(0, 2), 10);
    var century = (input.substr(0, 2) >= thisYear.substr(2, 2) ? thisCentury - 1 : thisCentury) + '';
    var dateString = century + input.substr(0, 6);
    return new Date(dateString.substr(0, 4) + '-' + dateString.substr(4, 2) + '-' + dateString.substr(6, 2));
  }

  function fullYearsFromDate(date) {
    return Math.floor((new Date() - date) / 1000 / 60 / 60 / 24 / 365);
  }

  function leftPad(number) {
    return (number + '').length === 1 ? '0' + number : '' + number;
  }

  function getIsoMonth(date) {
    return leftPad(date.getMonth() + 1);
  }

  function getIsoDate(date) {
    return leftPad(date.getDate());
  }

  var isValidSsn = function isValidSsn(input, options) {
    var ssnDate = getSsnDate(input);

    // Check year
    if ((ssnDate.getFullYear() + '').substr(2, 2) !== input.substr(0, 2)) {
      return false;
    }

    // Check month
    if (getIsoMonth(ssnDate) !== input.substr(2, 2)) {
      return false;
    }

    // Check date
    if (getIsoDate(ssnDate) !== input.substr(4, 2)) {
      return false;
    }

    // Check min years
    if (options.minYears !== false && fullYearsFromDate(ssnDate) < options.minYears) {
      var birthdayToCheck = new Date(ssnDate.getFullYear() + parseInt(options.minYears, 10) + '-' + getIsoMonth(ssnDate) + '-' + getIsoDate(ssnDate));
      if (birthdayToCheck > new Date()) {
        return false;
      }
    }

    return hasValidControlDigit(input);
  };

  var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  var defaultOptions = {
    minYears: 0
  };

  var pattern = /^\d{6}[-|(\s)]{0,1}\d{4}$/;

  var hasValidPattern = function hasValidPattern(input) {
    return pattern.test(input);
  };

  var hasValidControlDigit$1 = hasValidControlDigit;

  var isValidSsn$1 = function isValidSsn$$1(input, inputOptions) {
    var options = _extends({}, defaultOptions, inputOptions);

    input = input + '';

    var hasPattern = hasValidPattern(input);

    if (!hasPattern) {
      return false;
    }

    input = input.replace(/\D/g, '');

    return isValidSsn(input, options);
  };

  var isValidOrgNo = function isValidOrgNo(input) {
    var isInValidFirstDigit = ['1'].indexOf(input.substr(0, 1)) > -1; // First digit should not be 1

    var isInValidThirdDigit = parseInt(input.substr(2, 1), 10) <= 1; // Third digit should not be 0 or 1

    return !isInValidFirstDigit && !isInValidThirdDigit && hasValidControlDigit$1(input);
  };

  var _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

  var defaultOptions$1 = {
    allowSsn: true,
    ssnMinYears: 16
  };

  var isValidOrgNo$1 = function isValidOrgNo$$1(input, inputOptions) {
    var options = _extends$1({}, defaultOptions$1, inputOptions);

    input = input + '';

    var hasPattern = hasValidPattern(input);

    if (!hasPattern) {
      return false;
    }

    input = input.replace(/\D/g, '');

    var isOrgNo = isValidOrgNo(input);

    if (!isOrgNo && options.allowSsn) {
      return isValidSsn$1(input, options);
    }

    return isOrgNo;
  };

  var isValidSwedishOrgNo = isValidOrgNo$1;

  exports.isValidOrgNo = isValidOrgNo$1;
  exports.isValidSwedishOrgNo = isValidSwedishOrgNo;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
